import ActualQrCode from './actual-qr-code';
import { useSelector } from 'react-redux';
import getImage from 'helpers/getImage';
import './loyalty-card.css';

const LoyaltyCard = ({
  mainTextColor,
  labelColor,
  bgColor,
  selectedImageTheme,
  customReferralId,
  userId,
  customName,
  customPoints,
}) => {
  const { storeConfig } = useSelector((state) => state.layoutReducer);
  const { logo, logoPath } = storeConfig || {};
  const storeLogo = getImage(logoPath || logo);

  // Use custom values if provided, otherwise use default values
  const referralId = customReferralId || '1231 065 366';
  const displayName = customName
    ? customName.toUpperCase()
    : 'JOHNNY APPLESEED';
  const pointsBalance = customPoints !== undefined ? customPoints : 7584;

  // Generate QR code content with member information
  const qrCodeContent = `Coming soon TM`;

  return (
    <div className='loyalty-card w-full' style={{ backgroundColor: bgColor }}>
      <div className='loyalty-card-header flex justify-between'>
        <div className='self-center'>
          {storeLogo && (
            <img
              className='max-h-[40px] w-auto max-w-[100px]'
              src={storeLogo}
              alt='logo'
            />
          )}
        </div>
        <div>
          <div className='membership-text' style={{ color: labelColor }}>
            Membership
          </div>
          <div className='membership-id' style={{ color: mainTextColor }}>
            {referralId}
          </div>
        </div>
      </div>
      <div className='loyalty-card-design w-full'>
        {selectedImageTheme && (
          <img
            className='w-full h-full object-cover'
            src={selectedImageTheme}
            alt='logo'
          />
        )}
      </div>
      <div className='loyalty-secondary'>
        <div className='flex-1'>
          <div
            className='text-[12px] font-medium'
            style={{ color: labelColor }}
          >
            NAME
          </div>
          <div
            style={{ color: mainTextColor }}
            className='font-medium text-[17px]'
          >
            {displayName}
          </div>
        </div>
        <div>
          <div
            className='text-[12px] font-medium'
            style={{ color: labelColor }}
          >
            POINTS BALANCE
          </div>
          <div
            style={{ color: mainTextColor }}
            className='text-right font-medium text-[17px]'
          >
            {pointsBalance.toLocaleString()}
          </div>
        </div>
      </div>
      <div className='loyalty-qrcode'>
        <div className='flex justify-center'>
          <ActualQrCode
            text={`<qr>userId:${userId}</qr>`}
            color='#000000'
            size={150}
          />
        </div>
      </div>
    </div>
  );
};

export default LoyaltyCard;
